var OptionLooks;
(function (OptionLooks) {
  OptionLooks["Default"] = 'default';
})(OptionLooks || (OptionLooks = {}));
export { OptionLooks };